
                  export default function (Component) {
                      Component.__source = "library/components/VabFold/index.vue"
                  }
              